import { render, staticRenderFns } from "./ScoreGauge.vue?vue&type=template&id=57c5ada6&scoped=true&"
import script from "./ScoreGauge.vue?vue&type=script&lang=js&"
export * from "./ScoreGauge.vue?vue&type=script&lang=js&"
import style0 from "./ScoreGauge.vue?vue&type=style&index=0&id=57c5ada6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c5ada6",
  null
  
)

export default component.exports